import { Flex, type FlexProps } from '@/ui';

export const EntryModalBody = (props: FlexProps) => {
  return (
    <Flex
      direction="column"
      flex="1"
      overflowY="auto"
      pb="2"
      px={{ base: 6, sm: 12 }}
      {...props}
    />
  );
};
